export default __webpack_public_path__ + "static/kubeflow-d5e62f48345da24306bddbb45871cc6c.png";